<template>
  <div id="danh-sach-can-bo-truc-thuoc">
    <DataTable
      :value="danhSachCanBoTrucThuoc"
      :loading="isLoadingTable"
      dataKey="id"
      class="p-datatable-customers table"
    >
      <Column
        field="id"
        dataKey="id"
        headerStyle="width: 40px"
        headerClass="p-2"
        header="STT"
        bodyStyle="text-align: center"
      >
        <template #filter> </template>
        <template #body="slotProps">
          <span>{{
            (filterForm.index - 1) * filterForm.pageSize +
            (slotProps.index += 1)
          }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="hoTen"
        header="Họ tên"
        headerStyle="minWidth: 150px"
      >
        <template #body="slotProps">
          <span>{{ slotProps.data.hoTen }}</span>
        </template>
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.HoTenFilter"
            @change="layDanhSachCanBoTrucThuocDonVi"
          />
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="hoTen"
        header="Mã cán bộ"
        headerStyle="minWidth: 150px"
      >
        <template #body="slotProps">
          <span>{{ slotProps.data.maCanBo }}</span>
        </template>
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.MaCanBoFilter"
            @change="layDanhSachCanBoTrucThuocDonVi"
          />
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="chucVu"
        header="Chức vụ"
        headerStyle="minWidth: 150px"
      >
        <template #body="slotProps">
          <div class="">
            <div v-for="(item, index) in slotProps.data.chucVu" :key="index">
              - {{ item }}
            </div>
          </div>
        </template>
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.ChucVuFilter"
            @change="layDanhSachCanBoTrucThuocDonVi"
          />
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="phone_DiDong"
        header="SĐT"
        headerStyle="minWidth: 120px"
      >
        <template #body="slotProps">
          <div class="text-center">
            <span>{{ slotProps.data.phone_DiDong }}</span>
          </div>
        </template>
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.SdtFilter"
            @change="layDanhSachCanBoTrucThuocDonVi"
          />
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="ngaySinh"
        header="Ngày sinh"
        headerStyle="minWidth: 150px"
      >
        <template #body="slotProps">
          <div class="text-center">
            <span>{{ formatDateTime(slotProps.data.ngaySinh) }}</span>
          </div>
        </template>
        <template #filter>
          <date-picker
            format="DD/MM/YYYY"
            class="d-block w-100 custom-input"
            placeholder="Chọn ngày"
            v-model="NgaySinhFilter"
            range
            @change="layDanhSachCanBoTrucThuocDonVi"
          ></date-picker>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="email"
        header="Email"
        headerStyle="minWidth: 150px"
      >
        <template #body="slotProps">
          <span>{{ slotProps.data.email }}</span>
        </template>
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.EmailFilter"
            @change="layDanhSachCanBoTrucThuocDonVi"
          />
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="diaChi"
        header="Địa chỉ"
        headerStyle="minWidth: 150px"
      >
        <template #body="slotProps">
          <span>{{ slotProps.data.diaChi }}</span>
        </template>
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            @change="layDanhSachCanBoTrucThuocDonVi"
            v-model="requestForm.DiaChiFilter"
          />
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="hoatDong"
        header="Thao tác"
        headerClass="p-2"
        headerStyle="width: 80px"
      >
        <template #body="slotProps">
          <div class="text-center">
            <font-awesome-icon
              icon="trash-alt"
              v-b-popover.hover.top="'Xóa khỏi đơn vị'"
              class="cursor-pointer color-red"
              @click="removeCanBo(slotProps.data)"
            />
          </div>
        </template>
      </Column>
      <template #empty
        ><div class="text-center">Không có dữ liệu</div></template
      >
      <template #loading
        ><div class="text-center">Đang tải dữ liệu ...</div>
      </template>
    </DataTable>
    <BasePagination
      :total-pages="totalPages"
      :total-rows="totalRows"
      :current-page="filterForm.index"
      :is-loading="isLoadingTable"
      @changePages="onChangePages($event)"
      @changeNum="onChangeNum($event)"
    />
    <ModalConfirm
      :title="(itemCanBo || {}).hoTen"
      :titleOptional="' khỏi đơn vị'"
      ref="ModalXoaCanBoKhoiDonVi"
      :isLoading="isLoadingAction"
      @confirmed="xoaCanBoKhoiDonVi"
    />
  </div>
</template>
<script>
const defaultRequestForm = {
  HoTenFilter: "",
  ChucVuFilter: "",
  SdtFilter: "",
  NgaySinhStartFilter: null,
  NgaySinhEndFilter: null,
  EmailFilter: "",
  DiaChiFilter: "",
};
import ModalConfirm from "@/components/modal/ModalConfirm";
import _cloneDeep from "lodash/cloneDeep";
import { mapGetters } from "vuex";
import moment from "moment";
import BasePagination from "@/components/common/BasePagination";
export default {
  name: "DanhSachCanBoTrucThuoc",
  data() {
    return {
      itemCanBo: {},
      isLoadingAction: false,
      isLoadingTable: false,
      totalPages: 0,
      totalRows: 0,
      filterForm: {
        index: 1,
        pageSize: 10,
      },
      requestForm: _cloneDeep(defaultRequestForm),
      NgaySinhFilter: [],
    };
  },
  components: {
    BasePagination,
    ModalConfirm,
  },
  computed: {
    ...mapGetters({
      canBoTrucThuoc: "donVi/danhSachCanBoTrucThuoc",
    }),
    danhSachCanBoTrucThuoc() {
      if (!this.canBoTrucThuoc) {
        return [];
      }
      return (this.canBoTrucThuoc || []).items;
    },
  },
  props: {
    idDonVi: {},
  },
  watch: {
    idDonVi: {
      handler() {
        this.requestForm = _cloneDeep(defaultRequestForm);
      },
    },
  },

  methods: {
    formatDateTime(date) {
      if (date) {
        return moment(date).format("DD/MM/YYYY");
      }
      return date;
    },
    layDanhSachCanBoTrucThuocDonVi() {
      this.isLoadingTable = true;
      if (this.NgaySinhFilter && this.NgaySinhFilter.length) {
        if (this.NgaySinhFilter && this.NgaySinhFilter.length) {
          this.requestForm.NgaySinhStartFilter =
            moment(this.NgaySinhFilter[0])?.format("MM/DD/YYYY") || null;
          this.requestForm.NgaySinhEndFilter =
            moment(this.NgaySinhFilter[1])?.format("MM/DD/YYYY") || null;
        } else {
          this.requestForm.NgaySinhStartFilter = null;
          this.requestForm.NgaySinhEndFilter = null;
        }
      } else {
        this.requestForm.NgaySinhStartFilter = null;
        this.requestForm.NgaySinhEndFilter = null;
      }
      let payload = {
        ID_DonVi: this.idDonVi,
        IsGetAll: false,
        PageIndex: this.filterForm.index,
        PageSize: this.filterForm.pageSize,
        SortBy: "ThuTu asc",
        IsGetCanBoHoatDong: true,
        ...this.requestForm,
      };
      this.$store
        .dispatch("donVi/layDanhSachCanBoTrucThuoc", payload)
        .then((res) => {
          this.isLoadingTable = false;
          this.totalPages = res.data.data.totalPage;
          this.totalRows = res.data.data.totalCount;
        });
    },
    onChangeNum(pageSize) {
      this.filterForm.index = 1;
      this.filterForm.pageSize = pageSize;
      this.layDanhSachCanBoTrucThuocDonVi();
    },
    onChangePages(page) {
      this.filterForm.index = page;
      this.layDanhSachCanBoTrucThuocDonVi();
    },
    xoaCanBoKhoiDonVi() {
      let payload = {
        donViId: this.idDonVi,
        lstCanBo: [{ CanBoId: this.itemCanBo.id }],
      };
      this.isLoadingAction = true;
      this.$store
        .dispatch("donVi/xoaCanBo", payload)
        .then((res) => {
          this.isLoadingAction = false;
          if (res.data.succeeded) {
            this.layDanhSachCanBoTrucThuocDonVi();
            this.$toasted.global.showSuccessMessage({
              message: "Xoá thành công cán bộ",
            });
            this.$refs.ModalXoaCanBoKhoiDonVi.hideModal();
          } else {
            this.$toasted.clear();
            this.$toasted.global.showSuccessMessage({
              message: "Xoá không thành công",
            });
          }
        })
        .catch(() => {
          this.$toasted.global.showErrorMessage({
            message: "Xóa không thành công",
          });
        });
    },
    removeCanBo(item) {
      this.itemCanBo = item;
      this.$refs.ModalXoaCanBoKhoiDonVi.showModal();
    },
  },
};
</script>
<style lang="scss">
#danh-sach-can-bo-truc-thuoc {
  .mx-datepicker {
    width: 100% !important;
    .mx-input {
      border-radius: 0 !important;
      border: none !important;
      &:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #bbdefb;
      }
    }
  }
}
</style>